interface OnboardingPagesConfigType {
  backgroundImage: {
    png: string;
    webp: string;
  };
  content: {
    title: string;
    description: string;
  };
}

type OboardStatusChangeFunction = (status: onBoardingStatus) => void;

type onBoardingStatus = 'firstVipRegistration' | 'firstLogin' | 'completed';

const onBoardStatusesOrder: onBoardingStatus[] = [
  'firstLogin',
  'firstVipRegistration',
  'completed',
];

export { onBoardStatusesOrder };
export type {
  OboardStatusChangeFunction,
  OnboardingPagesConfigType,
  onBoardingStatus,
};
